import { ShoesState } from 'src/types'
import { meshMaterialWithFoldingTongue, meshMaterialWithLaceTypeAndStandingTongue } from './meshMatrial'

const sideBaseWithLaceAndStandingTongue = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.mainUnit.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(26, 441) //つま先＿左下
  ctx.quadraticCurveTo(105, 481, 204, 500)
  ctx.quadraticCurveTo(290, 519, 404, 497)
  ctx.quadraticCurveTo(457, 487, 548, 488)
  ctx.quadraticCurveTo(695, 355, 843, 322)

  ctx.quadraticCurveTo(838, 309, 818, 308)
  ctx.quadraticCurveTo(766, 310, 731, 269)
  ctx.quadraticCurveTo(688, 255, 614, 179)
  ctx.quadraticCurveTo(633, 196, 617, 214)
  ctx.quadraticCurveTo(583, 234, 543, 247)
  ctx.quadraticCurveTo(513, 273, 488, 284)
  ctx.quadraticCurveTo(423, 312, 370, 323)
  ctx.quadraticCurveTo(336, 330, 336, 330)
  ctx.quadraticCurveTo(279, 358, 217, 360)
  ctx.quadraticCurveTo(117, 356, 78, 367)
  ctx.quadraticCurveTo(18, 385, 26, 441)
  //   ctx.quadraticCurveTo(0, 0, 0, 0)
  //   ctx.quadraticCurveTo(0, 0, 0, 0)

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = '#383838'
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(543, 248) //
  ctx.quadraticCurveTo(676, 335, 754, 353)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'
  meshMaterialWithLaceTypeAndStandingTongue(ctx, state) // メッシュ
  //   canvasResetter(ctx) // リセット
}

const openingReinforcement = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.openingReinforcement.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(542, 257) // 左下
  ctx.quadraticCurveTo(600, 300, 700, 320) // 中央
  ctx.quadraticCurveTo(760, 330, 838, 320) // 右下
  ctx.quadraticCurveTo(826, 256, 826, 256) // 右上
  ctx.quadraticCurveTo(776, 259, 776, 259)
  ctx.quadraticCurveTo(758, 280, 712, 284)
  ctx.quadraticCurveTo(655, 285, 589, 220)
  ctx.quadraticCurveTo(536, 244, 536, 244)
  ctx.quadraticCurveTo(542, 257, 542, 257)
  //   ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = 'white'
  ctx.lineWidth = 2.5
  ctx.beginPath()
  ctx.moveTo(540, 257)
  ctx.quadraticCurveTo(600, 300, 700, 320) // 中央
  ctx.quadraticCurveTo(760, 330, 838, 320) // 右下
  //   ctx.quadraticCurveTo()
  //   ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(542, 250) // 左下
  ctx.quadraticCurveTo(600, 293, 700, 313) // 中央
  ctx.quadraticCurveTo(760, 323, 838, 313) // 右下
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'
}

const defaultSideBase = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.mainUnit.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(26, 441) //つま先＿左下
  ctx.quadraticCurveTo(105, 481, 204, 500)
  ctx.quadraticCurveTo(290, 519, 404, 497)
  ctx.quadraticCurveTo(457, 487, 548, 488)
  ctx.quadraticCurveTo(695, 355, 843, 322)
  ctx.quadraticCurveTo(834, 300, 830, 265) // 右上 / かかと
  ctx.quadraticCurveTo(776, 259, 776, 259) // 右上 / かかと左
  //   ctx.quadraticCurveTo()

  ctx.quadraticCurveTo(700, 325, 582, 214)
  ctx.quadraticCurveTo(583, 234, 543, 247)
  ctx.quadraticCurveTo(513, 273, 488, 284)
  ctx.quadraticCurveTo(423, 312, 370, 323)
  ctx.quadraticCurveTo(336, 330, 336, 330)
  ctx.quadraticCurveTo(279, 358, 217, 360)
  ctx.quadraticCurveTo(117, 356, 78, 367)
  ctx.quadraticCurveTo(18, 385, 26, 441)
  //   ctx.quadraticCurveTo(0, 0, 0, 0)

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = '#383838'
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(520, 250) //
  ctx.quadraticCurveTo(580, 370, 771, 342)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'
  meshMaterialWithFoldingTongue(ctx, state) // メッシュ

  openingReinforcement(ctx, state)

  //   canvasResetter(ctx) // リセット
}

export const sideBase = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  const openingPattern = state.openingPattern.value
  if (openingPattern === 'quarterCut') {
    sideBaseWithLaceAndStandingTongue(ctx, state)
    return
  }
  defaultSideBase(ctx, state)
}

// ctx.beginPath()
// ctx.moveTo(0, 0)
// ctx.quadraticCurveTo(0, 0, 0, 0)
// ctx.closePath()
